<template>
  <div class="persona-the-voice-glo-intro-content" id="identidade-verbal-persona-a-voz-da-glo" data-search-anchor>
    <div class="intro-persona-the-voice-glo-wrapper">
      <h1 class="intro-persona-the-voice-glo-title">{{ introTitle }}</h1>
    </div>
    <div class="intro-persona-the-voice-glo-paragraphs">
      <p class="intro-persona-the-voice-glo-paragraph">{{ introParagraph1 }}</p>
      <p class="intro-persona-the-voice-glo-paragraph">{{ introParagraph2 }}</p>     
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonaPageMixin from '@/mixins/persona-page-mixin'
import { PersonaPageStore } from '@/store/verbal-identity-page/persona-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonTheVoiceOfGloSection extends Mixins(PersonaPageMixin) {
  personaPageStore: PageStoreContract = getModule(PersonaPageStore, this.$store)

  get introTitle(): string {
    return this.getElementTitle(2, 0)
  }

  get introParagraph1(): string {
    return this.getElementText(2, 1)
  }

  get introParagraph2(): string {
    return this.getElementText(2, 2)
  }

  async getPersonaPage(): Promise<void> {
    await this.personaPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personaPageStore.isLoading) {
      await this.getPersonaPage()
    }
  }
}
</script>

<style lang="scss">
.persona-the-voice-glo-intro-content {
  display: grid;
  align-items: center;
  flex-direction: column;
  width: 1032px;
}

.intro-persona-the-voice-glo-wrapper {
  display: grid;
  justify-items: center;
}

.intro-persona-the-voice-glo-title {
  font-size: 56px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -0.01em;
  text-align: center;
  width: 790px;
  height: 72px;
  margin-top: 45px;
  margin-bottom: 100px;
}

.intro-persona-the-voice-glo-paragraphs {
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;
}

.intro-identidade-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.intro-persona-the-voice-glo-paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  white-space: pre-line;
  width: 503px;
  margin-top: 0;
}

</style>
